import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  coursesOrderFilterMenuAscendantCurses: {
    id: 'course-authoring.studio-home.courses.tab.order-filter-menu.ascendant-courses',
    defaultMessage: 'Name A-Z',
  },
  coursesOrderFilterMenuDescendantCurses: {
    id: 'course-authoring.studio-home.courses.tab.order-filter-menu.descendant-courses',
    defaultMessage: 'Name Z-A',
  },
  coursesOrderFilterMenuNewestCurses: {
    id: 'course-authoring.studio-home.courses.tab.order-filter-menu.newest-courses',
    defaultMessage: 'Newest',
  },
  coursesOrderFilterMenuOldestCurses: {
    id: 'course-authoring.studio-home.courses.tab.order-filter-menu.oldest-courses',
    defaultMessage: 'Oldest',
  },
});

export default messages;
